import { render, staticRenderFns } from "./ReportesSeriePantalla.vue?vue&type=template&id=5882b4b5&"
import script from "./ReportesSeriePantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSeriePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports